import { PublicApiClient } from '@/services/PublicApiClient'
import { RetailerApiClient } from '@/services/RetailerApiClient'

export default {
  getCategories() {
    return RetailerApiClient.get('tarfin-pro-categories')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProducts(categoryId) {
    return RetailerApiClient.get('tarfin-pro-products/' + categoryId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuotations(query) {
    return RetailerApiClient.get('tarfin-pro-quotations', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTopQuotations() {
    return RetailerApiClient.get('tarfin-pro-quotations/top')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getQuotation(id) {
    return RetailerApiClient.get('tarfin-pro-quotations/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createQuotation(quotation) {
    return RetailerApiClient.post('tarfin-pro-quotations', { payload: quotation })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  acceptQuotation(quotation) {
    return RetailerApiClient.patch(`tarfin-pro-quotations/${quotation.id}/accept`, {
      payload: {
        selected_item_brands: quotation.selectedItemBrands
      }
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  selectPaymentMethod(id, payload) {
    return RetailerApiClient.post(`tarfin-pro-quotations/${id}/store-payment-method`, { payload })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  changePaymentMethod(id, payload) {
    return RetailerApiClient.patch(`tarfin-pro-quotations/${id}/change-payment-method`, { payload })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelQuotation(quotation) {
    return RetailerApiClient.patch(`tarfin-pro-quotations/${quotation.id}/cancel`, {
      rejection_reason: quotation.rejection_reason
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  cancelQuotationProduct(quotation) {
    return RetailerApiClient.patch(`tarfin-pro-quotations/${quotation.id}/cancel-product`, {
      retailer_rejection_reason: quotation.rejection_reason,
      quotation_item_id: quotation.quotation_item_id
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  restoreQuotationProduct(quotation) {
    return RetailerApiClient.patch(`tarfin-pro-quotations/${quotation.id}/restore-product`, {
      quotation_item_id: quotation.quotation_item_id
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocument(quotationId, documentId, file) {
    let formData = new FormData()
    formData.append('payload[file]', file.file)
    formData.append('payload[type]', file.type)

    return RetailerApiClient
      .postForm(`tarfin-pro-quotations/${quotationId}/documents/${documentId}/upload`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadDocumentFromMobile(hash, documentId, file) {
    let formData = new FormData()
    formData.append('file', file.file)
    formData.append('type', file.type)

    return PublicApiClient
      .postForm(`tarfin-pro-document-mobile-upload/${hash}/document/${documentId}`, formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  viewSignedDocument(documentId, mimeType) {
    return RetailerApiClient.get(`tarfin-pro-quotations/view-signed-document/${documentId}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: mimeType })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  viewOriginalDocument(documentId) {
    return RetailerApiClient.get(`tarfin-pro-quotations/view-original-document/${documentId}`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        let blob = new Blob([response], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getQrCode(id) {
    return RetailerApiClient.get(`tarfin-pro-quotations/${id}/generate-qr-for-mobile-upload`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validateHash(hash) {
    return PublicApiClient.post(`tarfin-pro-quotations/validate-hash`, { hash })
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      })
  },
  generateMaturityOption(id) {
    return RetailerApiClient.post(`tarfin-pro-quotations/${id}/generate-maturity-options`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  sendVerifyPhoneOTPCodeProQuotation(id, phone) {
    return RetailerApiClient.post(`tarfin-pro-quotations/${id}/send-otp-for-quotation-credit-card-phone`, {
      phone
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  verifyPhoneOTPCodeProQuotation(code, id) {
    return RetailerApiClient.post(`tarfin-pro-quotations/${id}/verify-otp-for-quotation-credit-card-phone`, {
      code
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
